export const environment = {
    production: false,
    apiUrl: "https://app-01-yllwcore-backend-weu-qa.azurewebsites.net",
    environmentName: "QA",
    frontEndUrl: "https://core-qa.yllw.com",
    ssoClientId: "a575ef00-d014-41a6-b587-2bd823aae1f7",
    enableStoreDevtools: true,
    devtoolsMaxAge: 200,
    signInLoadingTimeMs: 3000,
    devtoolsLogOnly: false,
    scopes: {
        read: ["api://2e6fe21d-e21a-49ca-b892-d00ced62506d/YllwCore.ReadWrite"],
        write: ["api://2e6fe21d-e21a-49ca-b892-d00ced62506d/YllwCore.ReadWrite"],
    },
    InactiveCustomersBCCompanyId: "44f59775-5863-ee11-8def-0022489a2d3f",
    InactiveCustomersBCEnvironment: "yllw_qa",
};
